import { SubAPI } from "./SubAPI";

export class ApiTokens extends SubAPI {
    list(props: { includeArchived?: boolean }) {
        return this.fetcher.get<ApiToken[]>("/api/api-tokens", props);
    }

    // creating takes a name and an expiry, revoking takes an id and archived. A token
    // has nothing else worth editing.
    upsert(props: { id?: number; name?: string; expiresAt?: string; archived?: boolean }) {
        return this.fetcher.post<ApiToken>("/api/api-token", props);
    }
}

export type ApiToken = {
    id: number;
    usr: number;
    name: string;

    // the leading, non-secret part of the token, which is all a list can show of it
    prefix: string;

    expiresAt: string;
    lastUsedAt: string | null;
    archived: boolean;
    createdAt: string;
    createdBy: number;
    updatedAt: string;

    // the token itself, filled in only by the response that created it
    token: string;
}
